import { render, staticRenderFns } from "./claimAccident.vue?vue&type=template&id=a02590be&"
import script from "./claimAccident.vue?vue&type=script&lang=js&"
export * from "./claimAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports